module.exports = __webpack_public_path__ + "static/Apercu-Medium-bc5da6536355fb50d265da792b0f84b2.woff2";